<template>
  <TreeListLayoutAdapter>
    <template #tree>
      <rc-tree
        ref="rcTreeTableTree"
        v-bind="$attrs.tree"
        :tree-data-call="treeDataCall"
        v-on="$listeners"
        @node-click="nodeClick"
      />
    </template>
    <template #datatable>
      <div class="data-table-box">
        <component
          :is='componentName'
          :ref="tableName"
          :style="{ width: isChooseList && autoTableWidth ? '70%' : '100%' }"
          class="pt8 data-table"
          v-bind="$attrs"
          :params="{ ...defParams, ...$attrs.params }"
          :columns="comColumns"
          :is-mounted="false"
          :show-delete-model="false"
          :padding24="false"
          :replace-fields="replaceFields"
          v-on="$listeners"
          @table-select="tableSelect"
          @handleCurrentChange="handleCurrentChange"
          @table="tableCall"
        />
        <div v-if="chooseList.length" class="choose-list">
          <div @click="deleteAll">全删</div>
          <div v-for="(item, index) in chooseList" :key="index" class="choose-item" :class="index % 2 === 0 ? 'item-stripe' : ''">
            <div class="choose-item-text">{{ item[chooseShowKey] }}</div>
            <i slot="suffix" class="el-icon-delete cursor-p" @click="handleDelete(item, index)" />
          </div>
        </div>
      </div>
    </template>
  </TreeListLayoutAdapter>
</template>

<script>
import { toTypeStr } from "@/utils";

export default {
  name: "RcTreeTable",
  props: {
    componentName: {
      type: String,
      default: "rc-data-table"
    },
    merge: {
      type: Boolean,
      default: false
    },
    mergeList: Function,
    chooseKey: {
      type: String,
      default: "id"
    },
    chooseShowKey: {
      type: String,
      default: "displayName"
    },
    autoTableWidth: {
      type: Boolean,
      default: true
    },
    replaceFields: {
      type: Object,
      default: () => ({
        pageNum: "page",
        pageSize: "size"
      })
    },
    split: {
      type: String,
      default: "---tree-table---"
    }
  },
  data() {
    return {
      selection: [],
      selectionData: {},
      currentChooseKey: null,
      currentTableData: [],
      pageNum: 1,
      chooseList: [],
      defParams: {},
      defColumns: [{
        type: "selection",
        prop: "selection"
      }, {
        label: "用户名",
        prop: "displayName"
      }, {
        label: "姓名",
        prop: "username"
      }, {
        label: "手机号",
        prop: "cellphone"
      }]
    };
  },
  computed: {
    refs() {
      return this.refsFn();
    },
    tableName() {
      return toTypeStr(this.componentName);
    },
    table() {
      return this.refs[this.tableName];
    },
    baseTable() {
      return this.table.refs.table;
    },
    comColumns() {
      const { merge, defColumns, mergeList } = this;
      const { columns } = this.$attrs;
      return mergeList ? mergeList(columns, defColumns) : merge ? [...defColumns, columns] : defColumns;
    },
    isChooseList() {
      return Boolean(this.chooseList.length);
    }
  },
  methods: {
    refsFn() {
      return {
        [this.tableName]: this.$refs[this.tableName],
        rcTreeTableTree: this.$refs.rcTreeTableTree,
        ...this.$refs.rcTreeTableTree.refs,
        ...this.$refs[this.tableName].refs
      };
    },
    initDefParams(node, param) {
      const { tree } = this.$attrs;
      const key = tree && tree.rowKey || "id";
      this.defParams = {
        orgId: node[key],
        ...param
      };
    },
    initClick(node) {
      this.clearPage();
      this.setCurrentChooseKey(node);
      this.initDefParams(node);
    },
    nodeClick(node) {
      this.initClick(node);
      this.$nextTick(() => {
        this.table.refresh();
      });
    },
    treeDataCall({ first }) {
      if (first) {
        this.nodeClick(first);
      };
    },
    tableCall(table, data) {
      this.$nextTick(() => {
        this.currentTableData = data;
        this.setSelectionRow(table, data);
      });
    },
    setSelectionRow(table, data) {
      const { selectionData, currentChooseKey, pageNum, chooseKey, split } = this;
      const key = currentChooseKey + split + pageNum;
      const current = selectionData[key];
      const selection = current && current.selection;
      if (selection) {
        if (data) {
          const result = data.filter(stem => this.mapData(selection, chooseKey).includes(stem[chooseKey]));
          this.setToggleRowSelection(result);
        }
      }
    },
    setToggleRowSelection(arr) {
      (arr || []).map(row => {
        this.baseTable.toggleRowSelection(row);
      });
    },
    clearPage() {
      this.pageNum = 1;
    },
    setCurrentChooseKey(node) {
      this.currentChooseKey = node && node[this.chooseKey];
    },
    setData(selection) {
      const { selectionData, currentChooseKey, pageNum, split } = this;
      const key = `${currentChooseKey}${split}${pageNum}`;
      this.$set(selectionData, key, { selection });
      this.getChooseData();
    },
    createChooseData() {
      const { selectionData, chooseKey } = this;
      const arr = [];
      for (const key in selectionData) {
        const val = selectionData[key];
        const { selection } = val;
        if (selection.length) {
          if (selection && selection.length) {
            selection.map(item => {
              if (!this.mapData(arr, chooseKey).includes(item[chooseKey])) {
                arr.push(item);
              }
            });
          }
        }
      }
      return arr;
    },
    getChooseData() {
      this.chooseList = this.createChooseData();
    },
    setSelectionData(row, index) {
      this.clearSelection(row, index);
      this.setSelection(row, index);
      this.getChooseData();
    },
    clearSelection(row, index) {
      const { chooseKey, selectionData } = this;
      if (!row) {
        this.selectionData = {};
      } else {
        for (const key in selectionData) {
          const val = selectionData[key];
          const { selection } = val;
          if (selection.length) {
            val.selection = selection.filter(item => item[chooseKey] !== row[chooseKey]);
          }
        }
      }
    },
    setSelection(row, index) {
      const { chooseKey } = this;
      const resultRow = row && this.filterData(this.currentTableData, chooseKey, row[chooseKey]);
      if (row) {
        this.setToggleRowSelection(resultRow);
      } else {
        this.baseTable.clearSelection();
      }
    },
    handleCurrentChange(page) {
      if (page) {
        const { pageNum } = page;
        this.pageNum = pageNum;
      }
    },
    tableSelect(name, selection) {
      this.setData(selection);
    },
    mapData(arr, key) {
      if (!arr) { return []; };
      return arr.map(item => item[key]);
    },
    filterData(arr, key, condition) {
      if (!arr) { return []; };
      return arr.filter(item => item[key] === condition);
    },
    deleteAll() {
      this.setSelectionData();
    },
    handleDelete(row, index) {
      this.setSelectionData(row, index);
    },
    chooseData() {
      return this.chooseList;
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
    padding-right: 10px;
}
.search-bob {
    padding: 8px 4px 0 4px;
}
.data-table-box {
  width: 100%;
}
.data-table-box,.choose-item {
  display: flex;
  justify-content: space-between;
}
.data-table-box{
  width: 100%;
}
.choose-list {
  width: 30%;
  min-width: 160px;
  height: 300px;
  overflow: hidden;
  overflow-y: auto;
  border: 1px solid rgb(235, 236, 239);;
}
.item-stripe {
  background: $scim-color-table-block;
}
.choose-item {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .choose-item-text {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  font-size: 14px;
  color: $scim-sub-text-color;
  line-height: 30px;
}
</style>
